import { render, staticRenderFns } from "./SelectableCustomers.vue?vue&type=template&id=531695d8&"
import script from "./SelectableCustomers.vue?vue&type=script&lang=ts&"
export * from "./SelectableCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports